module.exports = __webpack_public_path__ + "img/dark-green-square-table-2.2fc288f3.png";